module.exports = __webpack_public_path__ + "scource/suzhi-silogan-transp-eca4a1ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/sidebar/img/suzhi-silogan-transp.png
// module id = 909
// module chunks = 1